module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/213cb4c8e933e1338088242d9af97029.svg";